"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("underscore");
const core_1 = require("@angular/core");
const reporting_service_1 = require("../reporting.service");
require("../Models");
const organisation_service_1 = require("../../organisation/services/organisation.service");
const dnaR_dropdown_multiSelect_model_1 = require("../../common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.model");
const common_1 = require("@angular/common");
const bed_status_enum_1 = require("./enums/bed-status.enum");
const support_status_enum_1 = require("./enums/support-status.enum");
const i0 = require("@angular/core");
const i1 = require("../../organisation/services/organisation.service");
const i2 = require("../reporting.service");
const i3 = require("@angular/common");
const i4 = require("@angular/forms");
const i5 = require("../../common/components/dnaR-datePicker/dnaR-datePicker.component");
const i6 = require("../../common/components/dnaR-dropdown-multiSelect/dnaR-dropdown-multiSelect.component");
function RoomsReportComponent_div_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\n                    ", ctx_r0.dateValidationError, "\n                ");
} }
function RoomsReportComponent_label_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.selectedFacility.text);
} }
function RoomsReportComponent_dnaR_dropdown_multiSelect_55_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dnaR-dropdown-multiSelect", 26);
    i0.ɵɵlistener("onSelectionChange", function RoomsReportComponent_dnaR_dropdown_multiSelect_55_Template_dnaR_dropdown_multiSelect_onSelectionChange_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.onFacilitySelectionChange($event); });
    i0.ɵɵtext(1, "\n                ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("settings", ctx_r2.dropdownSettings)("data", ctx_r2.facilities)("initialSelectedItems", ctx_r2.selectedFacilityIds);
} }
function RoomsReportComponent_div_59_label_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r10.roomTypes[0].name);
} }
function RoomsReportComponent_div_59_dnaR_dropdown_multiSelect_10_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dnaR-dropdown-multiSelect", 29);
    i0.ɵɵlistener("onSelectionChange", function RoomsReportComponent_div_59_dnaR_dropdown_multiSelect_10_Template_dnaR_dropdown_multiSelect_onSelectionChange_0_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.onRoomTypeSelectionChange($event); });
    i0.ɵɵtext(1, "\n                ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("settings", ctx_r11.dropdownSettings)("data", ctx_r11.roomTypes)("initialSelectedItems", ctx_r11.selectedRoomTypeIds);
} }
function RoomsReportComponent_div_59_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1, "\n            ");
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵelementStart(3, "label", 27);
    i0.ɵɵtext(4, "Room types");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5, "\n            ");
    i0.ɵɵelementStart(6, "div", 8);
    i0.ɵɵtext(7, "\n                ");
    i0.ɵɵtemplate(8, RoomsReportComponent_div_59_label_8_Template, 2, 1, "label", 14);
    i0.ɵɵtext(9, "\n                ");
    i0.ɵɵtemplate(10, RoomsReportComponent_div_59_dnaR_dropdown_multiSelect_10_Template, 2, 3, "dnaR-dropdown-multiSelect", 28);
    i0.ɵɵtext(11, "\n            ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(12, "\n        ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", ctx_r3.roomTypes.length == 1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.roomTypes.length > 1);
} }
function RoomsReportComponent_label_69_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r4.bedStatuses[0].name);
} }
function RoomsReportComponent_dnaR_dropdown_multiSelect_71_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dnaR-dropdown-multiSelect", 30);
    i0.ɵɵlistener("onSelectionChange", function RoomsReportComponent_dnaR_dropdown_multiSelect_71_Template_dnaR_dropdown_multiSelect_onSelectionChange_0_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.onBedStatusSelectionChange($event); });
    i0.ɵɵtext(1, "\n                ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("settings", ctx_r5.dropdownSettings)("data", ctx_r5.bedStatuses)("initialSelectedItems", ctx_r5.selectedBedStatusIds);
} }
function RoomsReportComponent_label_83_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.selectedSupportStatus);
} }
function RoomsReportComponent_dnaR_dropdown_multiSelect_85_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dnaR-dropdown-multiSelect", 31);
    i0.ɵɵlistener("onSelectionChange", function RoomsReportComponent_dnaR_dropdown_multiSelect_85_Template_dnaR_dropdown_multiSelect_onSelectionChange_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.onSupportStatusSelectionChange($event); });
    i0.ɵɵtext(1, "\n                ");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵproperty("settings", ctx_r7.dropdownSettings)("data", ctx_r7.supportStatuses)("initialSelectedItems", ctx_r7.selectedSupportStatusIds);
} }
class RoomsReportComponent {
    constructor(organisationService, reportingService, facilityService, notificationService, downloadFileService, datePipe) {
        this.organisationService = organisationService;
        this.reportingService = reportingService;
        this.facilityService = facilityService;
        this.notificationService = notificationService;
        this.downloadFileService = downloadFileService;
        this.datePipe = datePipe;
        this.dropdownSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'name',
            itemsShowLimit: 1,
            maxHeight: 500,
            addAllOption: false,
            enableCheckAll: false,
            showClearSelectedItems: false
        };
        this.facilitiesList = [];
        this.bedStatuses = [
            { name: bed_status_enum_1.BedStatusEnum.All, id: Object.keys(bed_status_enum_1.BedStatusEnum).indexOf(bed_status_enum_1.BedStatusEnum.All) },
            { name: bed_status_enum_1.BedStatusEnum.Available, id: Object.keys(bed_status_enum_1.BedStatusEnum).indexOf(bed_status_enum_1.BedStatusEnum.Available) },
            { name: bed_status_enum_1.BedStatusEnum.Occupied, id: Object.keys(bed_status_enum_1.BedStatusEnum).indexOf(bed_status_enum_1.BedStatusEnum.Occupied) },
            { name: bed_status_enum_1.BedStatusEnum.OutOfService, id: Object.keys(bed_status_enum_1.BedStatusEnum).indexOf(bed_status_enum_1.BedStatusEnum.OutOfService) },
        ];
        this.roomTypes = [];
        this.supportStatuses = [
            { name: support_status_enum_1.SupportStatusEnum.All, id: Object.keys(support_status_enum_1.SupportStatusEnum).indexOf(support_status_enum_1.SupportStatusEnum.All) },
            { name: support_status_enum_1.SupportStatusEnum.Supported, id: Object.keys(support_status_enum_1.SupportStatusEnum).indexOf(support_status_enum_1.SupportStatusEnum.Supported) },
            { name: support_status_enum_1.SupportStatusEnum.Unsupported, id: Object.keys(support_status_enum_1.SupportStatusEnum).indexOf(support_status_enum_1.SupportStatusEnum.Unsupported) },
            { name: support_status_enum_1.SupportStatusEnum.Bond, id: Object.keys(support_status_enum_1.SupportStatusEnum).indexOf(support_status_enum_1.SupportStatusEnum.Bond) },
            { name: support_status_enum_1.SupportStatusEnum.Charge, id: Object.keys(support_status_enum_1.SupportStatusEnum).indexOf(support_status_enum_1.SupportStatusEnum.Charge) },
            { name: support_status_enum_1.SupportStatusEnum.Respite, id: Object.keys(support_status_enum_1.SupportStatusEnum).indexOf(support_status_enum_1.SupportStatusEnum.Respite) },
            { name: support_status_enum_1.SupportStatusEnum.Unknown, id: Object.keys(support_status_enum_1.SupportStatusEnum).indexOf(support_status_enum_1.SupportStatusEnum.Unknown) },
        ];
        this.initialiseFilters = () => {
            this.reportFilters = {
                facility: "All",
                fromDate: this.fromDateUtc,
                toDate: this.toDateUtc,
                bedStatus: "All",
                roomTypes: "All",
                supportStatus: "All"
            };
            this.facilities = this.facilityService.activeUserFacilities.filter(x => x.facilityType == "AgeCare");
            if (this.facilities.length != 1) {
                this.facilities.unshift({ id: 0, name: "All", facilityType: "AgeCare", isBillingIntegratedFacility: false });
                this.facilities.forEach((facility) => {
                    this.facilitiesList.push(new dnaR_dropdown_multiSelect_model_1.ListItem({ id: facility.id, text: facility.name }));
                });
            }
            this.selectedFacility = { id: this.facilities[0].id.toString(), text: this.facilities[0].name, isHeader: false };
            this.selectedFacilityIds = [this.selectedFacility.id];
            this.reportFilters.fromDate = this.fromDateUtc;
            this.reportFilters.toDate = this.toDateUtc;
            this.selectedBedStatus = this.bedStatuses[0].id;
            this.selectedBedStatusIds = [this.bedStatuses[0].id.toString()];
            this.selectedSupportStatus = this.supportStatuses[0].id;
            this.selectedSupportStatusIds = [this.supportStatuses[0].id.toString()];
        };
        this.onFacilitySelectionChange = (selectedItems) => {
            if (selectedItems != null) {
                this.selectedFacility = selectedItems[0];
                this.reportFilters.facility = this.selectedFacility.text;
                //Needed for when facility filter changes from All to a single facility:
                this.setRoomTypesInformation(this.selectedFacility);
            }
            else {
                this.reportFilters.facility = "All";
            }
        };
        this.onRoomTypeSelectionChange = (selectedItems) => {
            if (selectedItems != null) {
                this.selectedRoomTypeIds = [selectedItems[0].id];
                this.reportFilters.roomTypes = selectedItems[0].text;
            }
        };
        this.onBedStatusSelectionChange = (selectedItems) => {
            if (selectedItems != null) {
                this.selectedBedStatusIds = [selectedItems[0].id];
                this.reportFilters.bedStatus = selectedItems[0].text;
            }
        };
        this.onSupportStatusSelectionChange = (selectedItems) => {
            if (selectedItems != null) {
                this.selectedSupportStatusIds = [selectedItems[0].id];
                this.reportFilters.supportStatus = selectedItems[0].text;
            }
        };
        this.onSubmit = () => {
            var runDateTime = this.datePipe.transform(new Date(), 'yyyy-MM-dd_HH.mm.ss');
            var fileName = `Rooms Report - ${runDateTime}.xlsx`;
            this.reportingService.getRoomsReportExcelStream(this.reportFilters).then((response) => {
                this.downloadFile(response, fileName);
            }, () => {
                this.notificationService.error("Error occurred while exporting Rooms report");
            });
        };
        this.downloadFile = (response, fileName) => {
            this.downloadFileService.downloadFile(response, fileName);
        };
        this.setRoomTypesInformation = (selectedFacility) => {
            if (selectedFacility.id > 0) {
                return this.organisationService.getRACAccommodationTypes(selectedFacility.id)
                    .then((result) => {
                    this.roomTypes = result;
                    if (this.roomTypes.length > 0) {
                        if (this.roomTypes.length > 1) {
                            this.roomTypes.unshift({ id: 0, name: "All" });
                        }
                        this.selectedRoomTypeId = this.roomTypes[0].id;
                        this.selectedRoomTypeIds = [this.selectedRoomTypeId.toString()];
                        this.reportFilters.roomTypes = this.roomTypes[0].name;
                    }
                    else {
                        this.notificationService.error("No room types were found.");
                    }
                }, () => {
                    this.notificationService.error("Unexpected error occurred while loading room types.");
                });
            }
        };
        var date = new Date();
        this.fromDateUtc = new Date(date.getFullYear(), date.getMonth(), 1);
        this.toDateUtc = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.initialiseFilters();
        this.setRoomTypesInformation(this.selectedFacility);
    }
    dateValidation() {
        this.dateValidationError = null;
        let itemStartDate = new Date(this.fromDateUtc);
        let itemEndDate = new Date(this.toDateUtc);
        // If we have start and end, validate the end date is after start date
        if (this.fromDateUtc && this.toDateUtc) {
            if (itemStartDate > itemEndDate) {
                this.dateValidationError = "End date must be after start date";
            }
        }
    }
    ;
    onStartDateValueChanged($event, item) {
        this.isDirty = true;
        if ($event.value != null) {
            // get the selected date      
            const selectedDate = new Date($event.value);
            // Convert the selected date to utc midnight
            var utcDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0, 0));
            // Store the UtcDate back on the item
            item = utcDate;
        }
        this.dateValidation();
        this.reportFilters.fromDate = item;
    }
    onEndDateValueChanged($event, item) {
        this.isDirty = true;
        if ($event.value != null) {
            // get the selected date      
            const selectedDate = new Date($event.value);
            // Convert the selected date to utc midnight
            var utcDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0, 0));
            // Store the UtcDate back on the item
            item = utcDate;
        }
        this.dateValidation();
        this.reportFilters.toDate = item;
    }
}
exports.RoomsReportComponent = RoomsReportComponent;
RoomsReportComponent.ɵfac = function RoomsReportComponent_Factory(t) { return new (t || RoomsReportComponent)(i0.ɵɵdirectiveInject(i1.OrganisationService), i0.ɵɵdirectiveInject(i2.ReportingService), i0.ɵɵdirectiveInject('facility.service'), i0.ɵɵdirectiveInject('notification.service'), i0.ɵɵdirectiveInject('downloadFile.service'), i0.ɵɵdirectiveInject(i3.DatePipe)); };
RoomsReportComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RoomsReportComponent, selectors: [["rooms-report"]], decls: 99, vars: 11, consts: [["nav-publisher", "reporting", 1, "rooms-export"], ["novalidate", "", 3, "ngSubmit"], [1, "row"], [1, "col-xs-6"], [1, "page-header"], [1, "row", "rooms-report-row"], [1, "col-xs-2", "rooms-report-label"], ["for", "fromDate", 1, "control-label", "v-align-middle"], [1, "col-xs-3", "rooms-report-field-row"], ["name", "startDate", "ngDefaultControl", "", "required", "true", "requiredError", "Start date required", 3, "ngModel", "ngModelChange", "onComponentChange"], ["for", "toDate", 1, "control-label", "v-align-middle"], ["name", "endDate", "required", "false", 3, "ngModel", "ngModelChange", "onComponentChange"], ["class", "text-danger", 4, "ngIf"], ["for", "facility", 1, "control-label", "label-facility"], ["class", "control-label no-margin v-align-middle", 4, "ngIf"], ["name", "facility", "data-automation", "facilities", 3, "settings", "data", "initialSelectedItems", "onSelectionChange", 4, "ngIf"], ["class", "row rooms-report-row", 4, "ngIf"], ["for", "bedStatus", 1, "control-label", "label-bedStatus"], ["name", "bedStatus", "data-automation", "bedStatuses", 3, "settings", "data", "initialSelectedItems", "onSelectionChange", 4, "ngIf"], [1, "row", "space-below-8", "rooms-report-row"], ["for", "supportStatus", 1, "control-label", "label-supportStatus"], ["name", "supportStatus", "data-automation", "supportStatuses", 3, "settings", "data", "initialSelectedItems", "onSelectionChange", 4, "ngIf"], ["ng-class", "margin-top-20", 1, "col-xs-6", "col-xs-offset-1", "export-button"], ["type", "submit", 1, "btn", "btn-primary", "btn-lg", 3, "disabled"], [1, "text-danger"], [1, "control-label", "no-margin", "v-align-middle"], ["name", "facility", "data-automation", "facilities", 3, "settings", "data", "initialSelectedItems", "onSelectionChange"], ["for", "roomType", 1, "control-label", "label-roomType"], ["name", "roomType", "data-automation", "roomTypes", 3, "settings", "data", "initialSelectedItems", "onSelectionChange", 4, "ngIf"], ["name", "roomType", "data-automation", "roomTypes", 3, "settings", "data", "initialSelectedItems", "onSelectionChange"], ["name", "bedStatus", "data-automation", "bedStatuses", 3, "settings", "data", "initialSelectedItems", "onSelectionChange"], ["name", "supportStatus", "data-automation", "supportStatuses", 3, "settings", "data", "initialSelectedItems", "onSelectionChange"]], template: function RoomsReportComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtext(1, "\n    ");
        i0.ɵɵelementStart(2, "form", 1);
        i0.ɵɵlistener("ngSubmit", function RoomsReportComponent_Template_form_ngSubmit_2_listener() { return ctx.onSubmit(); });
        i0.ɵɵtext(3, "\n        ");
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtext(5, "\n            ");
        i0.ɵɵelementStart(6, "div", 3);
        i0.ɵɵtext(7, "\n                ");
        i0.ɵɵelementStart(8, "h1", 4);
        i0.ɵɵtext(9, "Rooms");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(10, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(11, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(12, "\n        ");
        i0.ɵɵelementStart(13, "div", 5);
        i0.ɵɵtext(14, "\n            ");
        i0.ɵɵelementStart(15, "div", 6);
        i0.ɵɵtext(16, "\n                ");
        i0.ɵɵelementStart(17, "label", 7);
        i0.ɵɵtext(18, "From");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(19, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(20, "\n            ");
        i0.ɵɵelementStart(21, "div", 8);
        i0.ɵɵtext(22, "\n                ");
        i0.ɵɵelementStart(23, "dnaR-date-picker", 9);
        i0.ɵɵlistener("ngModelChange", function RoomsReportComponent_Template_dnaR_date_picker_ngModelChange_23_listener($event) { return ctx.fromDateUtc = $event; })("onComponentChange", function RoomsReportComponent_Template_dnaR_date_picker_onComponentChange_23_listener($event) { return ctx.onStartDateValueChanged($event, ctx.fromDateUtc); });
        i0.ɵɵtext(24, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(25, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(26, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(27, "\n        ");
        i0.ɵɵelementStart(28, "div", 5);
        i0.ɵɵtext(29, "\n            ");
        i0.ɵɵelementStart(30, "div", 6);
        i0.ɵɵtext(31, "\n                ");
        i0.ɵɵelementStart(32, "label", 10);
        i0.ɵɵtext(33, "To");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(34, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(35, "\n            ");
        i0.ɵɵelementStart(36, "div", 8);
        i0.ɵɵtext(37, "\n                ");
        i0.ɵɵelementStart(38, "dnaR-date-picker", 11);
        i0.ɵɵlistener("ngModelChange", function RoomsReportComponent_Template_dnaR_date_picker_ngModelChange_38_listener($event) { return ctx.toDateUtc = $event; })("onComponentChange", function RoomsReportComponent_Template_dnaR_date_picker_onComponentChange_38_listener($event) { return ctx.onEndDateValueChanged($event, ctx.toDateUtc); });
        i0.ɵɵtext(39, "\n                ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(40, "\n                ");
        i0.ɵɵtemplate(41, RoomsReportComponent_div_41_Template, 2, 1, "div", 12);
        i0.ɵɵtext(42, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(43, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(44, "\n        ");
        i0.ɵɵelementStart(45, "div", 5);
        i0.ɵɵtext(46, "\n            ");
        i0.ɵɵelementStart(47, "div", 6);
        i0.ɵɵelementStart(48, "label", 13);
        i0.ɵɵtext(49, "Facility");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(50, "\n            ");
        i0.ɵɵelementStart(51, "div", 8);
        i0.ɵɵtext(52, "\n                ");
        i0.ɵɵtemplate(53, RoomsReportComponent_label_53_Template, 2, 1, "label", 14);
        i0.ɵɵtext(54, "\n                ");
        i0.ɵɵtemplate(55, RoomsReportComponent_dnaR_dropdown_multiSelect_55_Template, 2, 3, "dnaR-dropdown-multiSelect", 15);
        i0.ɵɵtext(56, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(57, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(58, "\n        ");
        i0.ɵɵtemplate(59, RoomsReportComponent_div_59_Template, 13, 2, "div", 16);
        i0.ɵɵtext(60, "\n        ");
        i0.ɵɵelementStart(61, "div", 5);
        i0.ɵɵtext(62, "\n            ");
        i0.ɵɵelementStart(63, "div", 6);
        i0.ɵɵelementStart(64, "label", 17);
        i0.ɵɵtext(65, "Bed status");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(66, "\n            ");
        i0.ɵɵelementStart(67, "div", 8);
        i0.ɵɵtext(68, "\n                ");
        i0.ɵɵtemplate(69, RoomsReportComponent_label_69_Template, 2, 1, "label", 14);
        i0.ɵɵtext(70, "\n                ");
        i0.ɵɵtemplate(71, RoomsReportComponent_dnaR_dropdown_multiSelect_71_Template, 2, 3, "dnaR-dropdown-multiSelect", 18);
        i0.ɵɵtext(72, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(73, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(74, "\n        ");
        i0.ɵɵelementStart(75, "div", 19);
        i0.ɵɵtext(76, "\n            ");
        i0.ɵɵelementStart(77, "div", 6);
        i0.ɵɵelementStart(78, "label", 20);
        i0.ɵɵtext(79, "Support status");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtext(80, "\n            ");
        i0.ɵɵelementStart(81, "div", 8);
        i0.ɵɵtext(82, "\n                ");
        i0.ɵɵtemplate(83, RoomsReportComponent_label_83_Template, 2, 1, "label", 14);
        i0.ɵɵtext(84, "\n                ");
        i0.ɵɵtemplate(85, RoomsReportComponent_dnaR_dropdown_multiSelect_85_Template, 2, 3, "dnaR-dropdown-multiSelect", 21);
        i0.ɵɵtext(86, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(87, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(88, "\n        ");
        i0.ɵɵelementStart(89, "div", 2);
        i0.ɵɵtext(90, "\n            ");
        i0.ɵɵelementStart(91, "div", 22);
        i0.ɵɵtext(92, "\n                ");
        i0.ɵɵelementStart(93, "button", 23);
        i0.ɵɵtext(94, "Export report");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(95, "\n            ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(96, "\n        ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(97, "\n    ");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(98, "\n");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(23);
        i0.ɵɵproperty("ngModel", ctx.fromDateUtc);
        i0.ɵɵadvance(15);
        i0.ɵɵproperty("ngModel", ctx.toDateUtc);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.dateValidationError);
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("ngIf", ctx.facilities.length == 1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.facilities.length > 1);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.selectedFacility.text != "All");
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("ngIf", ctx.bedStatuses.length == 1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.bedStatuses.length > 1);
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("ngIf", ctx.supportStatuses.length == 1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.supportStatuses.length > 1);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("disabled", !ctx.fromDateUtc || !ctx.toDateUtc || ctx.toDateUtc < ctx.fromDateUtc);
    } }, directives: [i4.ɵangular_packages_forms_forms_y, i4.NgControlStatusGroup, i4.NgForm, i5.DnaRDatePicker, i4.DefaultValueAccessor, i4.RequiredValidator, i4.NgControlStatus, i4.NgModel, i3.NgIf, i6.DnaRDropdownMultiSelect], styles: [".rooms-report-row[_ngcontent-%COMP%] {\n  \n  height: auto;\n  padding-bottom: 20px;\n}\n.rooms-report-field-row[_ngcontent-%COMP%] {\n  padding-left: 5px;\n  padding-right: 7px;\n  color: #414141;\n  \n  font-family: Source Sans Pro;\n  font-size: 16px !important;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  \n}\n.rooms-report-label[_ngcontent-%COMP%] {\n  width: 10%;\n  padding-top: 5px;\n  color: #414141;\n  text-align: left;\n  \n  font-family: Source Sans Pro;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  \n}\n.no-margin[_ngcontent-%COMP%] {\n  margin: 0px;\n}\n.export-button[_ngcontent-%COMP%] {\n  padding-left: 22px;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(RoomsReportComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'rooms-report',
                templateUrl: './rooms-report.component.html',
                styleUrls: ['./rooms-report.component.less'],
                preserveWhitespaces: true
            }]
    }], function () { return [{ type: i1.OrganisationService }, { type: i2.ReportingService }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['facility.service']
            }] }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['notification.service']
            }] }, { type: undefined, decorators: [{
                type: core_1.Inject,
                args: ['downloadFile.service']
            }] }, { type: i3.DatePipe }]; }, null); })();
